import { createSceneReducer } from 'reducers/reducers-util';
import fieldWorkOrdersDataReducer from 'components/admin/field-work-orders/store/reducers.data';

export default createSceneReducer(fieldWorkOrdersDataReducer);
